import { http } from '@/lib/http';
import type { Refund, RefundStatus, RefundType } from '@/types/refunds';

const BASE = '/api/v1/refunds';
const ORDERS = '/api/v1/orders';

export interface RefundListQuery {
  status?: RefundStatus;
  type?: RefundType;
  salesOrderId?: string;
  returnOrderId?: string;
  page?: number;
  pageSize?: number;
}

export interface RefundListResponse {
  rows: Refund[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateRefundPayload {
  salesOrderId: string;
  paymentId?: string;
  returnOrderId?: string;
  type: RefundType;
  amount: number;
  currency?: string;
  externalRefundRef?: string;
  reason?: string;
  metadata?: Record<string, unknown>;
}

export interface UpdateRefundStatusPayload {
  status: RefundStatus;
  reason?: string;
  providerRefundId?: string;
}

export const refundsService = {
  list: (query: RefundListQuery = {}) =>
    http.get<RefundListResponse>(BASE, { params: query }),
  get: (id: string) => http.get<Refund>(`${BASE}/${id}`),
  create: (payload: CreateRefundPayload) =>
    http.post<Refund, CreateRefundPayload>(BASE, payload),
  updateStatus: (id: string, payload: UpdateRefundStatusPayload) =>
    http.patch<Refund, UpdateRefundStatusPayload>(`${BASE}/${id}/status`, payload),
  /** Order-scoped lookup — drives the in-order Refunds tab. */
  listForOrder: (orderId: string) =>
    http.get<Refund[]>(`${ORDERS}/${orderId}/refunds`),
};
